<template>
    <!-- <v-card class="mx-auto"  height="100vh" width="300"> -->
    <div id="NavLeft">
        <div v-if="stay">
            <v-navigation-drawer v-model="LeftDrawer"  height="100vh" app dark color="grey darken-4" temporary>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>

                        <v-list-item-title class="text-h6">
                            Retail Lite
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Tokaly
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list>
                    <v-list-item v-for="([icon, text,link], i) in items" :key="i" :to='link'>
                        <v-list-item-icon>
                            <v-icon>{{ icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ text }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </div>

        <div v-else>
            <v-navigation-drawer height="100vh" app dark color="grey darken-4" permanent>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-home</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>

                        <v-list-item-title class="text-h6">
                            Retail Lite
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            Tokaly
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list>
                    <v-list-item v-for="([icon, text,link], i) in items" :key="i" :to='link'>
                        <v-list-item-icon>
                            <v-icon>{{ icon }}</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>{{ text }}</v-list-item-title>
                        </v-list-item-content>

                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </div>

    </div>

    <!-- </v-card> -->
</template>

<script>
    export default {
        props: {
            LeftDrawer: Boolean,
            stay: Boolean
        },
        data: () => ({
            items: [
                ['mdi-sticker-emoji', 'Sticker Board', '/stickerboard'],
                ['mdi-gamepad', 'Available Games', '/avaiblegames'],
                ['mdi-bullhorn', 'Promotions', '/promotions'],
                ['mdi-trophy', 'Winnings', '/winnings']
            ],
        }),
    }
</script>